import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';

import * as styles from './Content.module.scss';

export default function Content({ title, subtitle, titleMod }) {
  return (
    <div className={styles.container}>
      <Title tag="h1" color="white" className={cn(styles.title, titleMod && styles[titleMod])}>
        {title}
      </Title>
      {subtitle && (
        <Subtitle tag="p" size="lg" color="white" className={styles.subtitle}>
          {subtitle}
        </Subtitle>
      )}
    </div>
  );
}
